module.exports = __webpack_public_path__ + "static/images/grid-right.4fcf20798ae55fa38d7e91d529f17d45.png";